document.addEventListener('DOMContentLoaded', function() {
    initVariantHandler();
});

function initVariantHandler() {
    const buyingCards = document.querySelectorAll('.buying-option-card');
    const variantRadios = document.querySelectorAll('.opt-btn');
    const variantInputs = document.querySelectorAll('input[name="id"]');
    const priceElement = document.getElementById('ProductPrice');
    
    if (!buyingCards.length) return;
    
    buyingCards[0]?.classList.add('active');
    
    buyingCards.forEach((card, index) => {
        card.addEventListener('click', function() {
            buyingCards.forEach(c => c.classList.remove('active'));
            this.classList.add('active');
            
            const priceText = this.querySelector('.option-price')?.textContent.trim();
            if (priceText) updateMainPrice(priceText);
            
            if (variantRadios.length > index) {
                variantRadios[index].click();
                variantRadios[index].dispatchEvent(new Event('change', { bubbles: true }));
            }
            
            if (variantInputs.length > 0) {
                const variantId = this.dataset.variantId;
                variantInputs.forEach(input => input.value = variantId);
            }
        });
    });
    
    variantRadios.forEach((radio, index) => {
        radio.addEventListener('change', function() {
            if (this.checked && buyingCards[index]) {
                buyingCards.forEach(c => c.classList.remove('active'));
                buyingCards[index].classList.add('active');
                
                const priceText = buyingCards[index].querySelector('.option-price')?.textContent.trim();
                if (priceText) updateMainPrice(priceText);
            }
        });
    });
    
    const activeCard = document.querySelector('.buying-option-card.active');
    if (activeCard) {
        const priceText = activeCard.querySelector('.option-price')?.textContent.trim();
        if (priceText) updateMainPrice(priceText);
    }
}

function updateMainPrice(priceText) {
    const priceElement = document.getElementById('ProductPrice');
    if (priceElement) {
        
        let cleanPrice = priceText.replace('+', '').replace(/\s+/g, '');
        priceElement.textContent = cleanPrice;
    }
    
    const comparePriceElement = document.getElementById('ComparePrice');
    if (comparePriceElement) {
        const activeCard = document.querySelector('.buying-option-card.active');
        if (activeCard && activeCard.querySelector('.option-price')?.textContent.includes('$0')) {
            comparePriceElement.style.display = 'inline';
        } else {
            comparePriceElement.style.display = 'none';
        }
    }
    
    if (typeof PriceCalculation === 'function') {
        setTimeout(PriceCalculation, 50);
    }
}

window.updateMainPrice = updateMainPrice;
window.initVariantHandler = initVariantHandler;